import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import axios from 'axios';
import Moment from 'moment';
// material
import {
  Card,
  Table,
  Stack,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  CircularProgress,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  FormControl,
  Select,
  Icon,
  Container,
  Typography,
  MenuItem,
  TableContainer,
  TablePagination,
  TextField,
  Grid,
  IconButton,
  Avatar,
  Popover,
  Chip,
} from '@mui/material';
import { Box } from '@mui/system';
import CopyToClipboard from 'react-copy-to-clipboard';
import { LoadingButton } from '@mui/lab';
import { useFormik, Form, FormikProvider } from 'formik';
import { Close, Visibility } from '@mui/icons-material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import AddIcon from '@mui/icons-material/Add';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import Filter from '../components/filters/AuthorFilter';

// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import Popup from '../components/popups/AuthorStatusChange';

export default function Authors() {
  const navigate = useNavigate();
  const [authorData, setAuthorData] = useState();
  const [pages, setPages] = useState(0);
  const [authorCount, setAuthorCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading1, setIsLoading1] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState();
  const [selectedIndex1, setSelectedIndex1] = useState();
  const size = 10;
  const [options, setOptions] = useState({ size, page: 0 });
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState(1);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open3, setOpen3] = useState(false);
  const mobileRegExp = '^[6789][0-9]{9}';

  const authorSchema = Yup.object().shape({
    name: Yup.string().required('Name is required').min(4, 'Name must be at least 4 charecters'),
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      isDisabled: 'false',
    },
    validationSchema: authorSchema,
    onSubmit: async () => {
      try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/author`, values, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (!res.data.isError) {
          closeAddAuthorModal(res.data.message);
        } else {
          toast.error(res.data.message);
        }
        getAuthors(options);
        resetForm();
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
    },
  });
  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, resetForm } = formik;

  const handleStatusChange = (event, item, index) => {
    console.log('item', item);
    if (`${!item.isBlocked}` === event.target.value) {
      return;
    }
    console.log(index);
    setSelectedIndex(index);
  };

  const handleClose = (refresh = false, message = '') => {
    setSelectedIndex();
    if (refresh) {
      getAuthors(options);
    }
    if (message && refresh) {
      toast(message);
    } else if (message && !refresh) {
      toast.error(message);
    }
  };
  const openAddUserModal = () => {
    setOpen(true);
  };
  const closeAddAuthorModal = (message) => {
    setOpen(false);
    toast(message);
  };

  const handlePageChange = (event, newPage) => {
    const temp = { ...options, page: newPage };
    setPages(newPage);
    setOptions(temp);
    setIsLoading(true);
    getAuthors(temp);
  };

  const getAuthors = (options) => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/author/all`, {
        params: options,
      })
      .then((res) => {
        console.log('res', res);
        if (res.data.isError === false) {
          setIsLoading(false);
          setAuthorCount(res.data.data.maxRecords);
          setAuthorData(res.data.data.records);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const goToPage = () => {
    console.log('hi');
    if (input > Math.ceil(authorCount / size)) {
      return;
    }
    setInput(input > 0 ? input : 1);
    setPages(input - 1 >= 0 ? input - 1 : 0);
    const temp = { ...options, page: input - 1 };
    setOptions(temp);
    getAuthors(temp);
  };

  const handleOpenPopover = (event, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex1(index);
    setOpen3(true);
    event.stopPropagation();
  };

  const handleClosePopover = (event) => {
    setAnchorEl(null);
    setSelectedIndex1('');
    setOpen3(false);
    event.stopPropagation();
  };

  const applyFilters = (filter) => {
    console.log('filter', filter);
    const temp = { page: 0, size };
    if (filter.id.length) {
      temp.id = filter.id;
    }
    if (filter.fullname.length) {
      temp.fullname = filter.fullname.trim();
    }
    if (filter.id.length) {
      temp.id = filter.id;
    }
    if (filter.email.length) {
      temp.email = filter.email;
    }
    if (filter.startDate) {
      temp.startDate = filter.startDate;
    }
    if (filter.endDate) {
      temp.endDate = filter.endDate;
    }
    if (filter.isBlocked.length) {
      temp.isBlocked = filter.isBlocked;
    }

    setOptions(temp);
    setPages(0);
    getAuthors(temp);
  };
  useEffect(() => {
    getAuthors(options);
  }, []);
  return (
    <>
      <Page title="Authors">
        {isLoading ? (
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50vh',
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <>
            {/* Add author Dialog */}
            <Dialog open={open}>
              <DialogTitle>Add Author</DialogTitle>
              <Grid container paddingBottom={'10px'} Width="500px">
                <DialogContent paddingTop="20px">
                  <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                      <Grid item xs={12} md={12} lg={12}>
                        <Stack direction={'column'} spacing={1} width="500px">
                          <Stack direction="row" justifyContent="space-between">
                            <TextField
                              type="text"
                              label="Name"
                              fullWidth
                              value={values.name}
                              {...getFieldProps('name')}
                              error={Boolean(touched.name && errors.name)}
                              helperText={touched.name && errors.name}
                            />
                          </Stack>
                          <Stack direction="row" justifyContent="space-between" spacing={1}>
                            <TextField
                              select
                              label="Account Status"
                              fullWidth
                              value={values.isDisabled}
                              {...getFieldProps('isDisabled')}
                              error={Boolean(touched.isDisabled && errors.isDisabled)}
                              helperText={touched.isDisabled && errors.isDisabled}
                            >
                              <MenuItem value="false">Active</MenuItem>
                              <MenuItem value="true">Blocked</MenuItem>
                            </TextField>
                            <TextField
                              fullWidth
                              type="file"
                              label="Profile Pic"
                              InputLabelProps={{ shrink: true }}
                              onChange={(e) => formik.setFieldValue('author', e.target.files[0])}
                            />
                          </Stack>
                        </Stack>
                      </Grid>
                      <Stack direction={'row'} justifyContent="flex-end" paddingTop="20px">
                        <Button onClick={closeAddAuthorModal}>Cancel</Button>
                        <LoadingButton type="submit" loading={isSubmitting}>
                          Add Author
                        </LoadingButton>
                      </Stack>
                    </Form>
                  </FormikProvider>
                </DialogContent>
              </Grid>
            </Dialog>
            {/* Add author dialog end */}
            <Container maxWidth="xl">
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ marginBottom: 1 }}>
                <Typography variant="h4" gutterBottom>
                  Authors
                </Typography>
              </Stack>
              <Card>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Stack direction="row" spacing={2} padding={2}>
                    <TextField
                      size="small"
                      style={{ maxWidth: '100px', maxHeight: '35px' }}
                      type="number"
                      component="div"
                      label="Go to"
                      value={input}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          goToPage();
                        }
                      }}
                      onInput={(e) => setInput(e.target.value)}
                    />
                    <Button variant="contained" onClick={goToPage} style={{ maxHeight: '35px' }}>
                      Go
                    </Button>
                  </Stack>
                  <Stack padding={1} direction="row" justifyContent="flex-end" spacing={2} alignItems="center">
                    <Button startIcon={<AddIcon />} variant="contained" onClick={openAddUserModal}>
                      Add Author
                    </Button>

                    {/* <Filter applyFilters={applyFilters} /> */}
                  </Stack>
                </Stack>

                <Scrollbar>
                  <TableContainer sx={{ minWidth: 800 }}>
                    <Table>
                      {/* <UserListHead /> */}
                      <TableHead>
                        <TableRow>
                          <TableCell>Sl No</TableCell>
                          <TableCell>Profile Pic</TableCell>
                          <TableCell>Name</TableCell>
                          <TableCell>Profile</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Member Since</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {authorData?.map((item, id) => (
                          <TableRow key={id} sx={{ '&:hover': { backgroundColor: '#FFE2E2' } }}>
                            <TableCell style={{ width: '50px' }}>{pages * size + (id + 1)}</TableCell>
                            <TableCell>
                              <Avatar
                                alt="Author"
                                src={item?.profilePic && item.profilePic.fileUrl}
                                onClick={(e) => handleOpenPopover(e, id)}
                                sx={{ width: 48, height: 48, cursor: 'pointer' }}
                              />
                              <Popover
                                open={open3 && selectedIndex1 === id}
                                anchorEl={anchorEl}
                                onClose={handleClosePopover}
                                disableRestoreFocus
                                anchorOrigin={{
                                  vertical: 'center',
                                  horizontal: 'center',
                                }}
                                transformOrigin={{
                                  vertical: 'top',
                                  horizontal: 'center',
                                }}
                              >
                                <Box
                                  sx={{
                                    p: 2,
                                    maxWidth: 280,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <IconButton
                                    onClick={handleClosePopover}
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      right: 0,
                                      color: 'text.secondary',
                                    }}
                                  >
                                    <Close />
                                  </IconButton>
                                  <Avatar
                                    src={item?.profilePic && item.profilePic.fileUrl}
                                    alt="Author"
                                    sx={{ width: 200, height: 200 }}
                                  />
                                  <Typography
                                    sx={{
                                      lineHeight: 1.2,
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {item.name}
                                  </Typography>
                                </Box>
                              </Popover>
                            </TableCell>
                            <TableCell
                              style={{
                                minWidth: '130px',
                                maxWidth: '220px',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden', 
                              }}
                            >
                              {item?.name}
                            </TableCell>
                            <TableCell>
                              <Chip
                                // eslint-disable-next-line no-nested-ternary
                                label={!item?.isDefault ? (item?.isAdmin ? 'Admin' : 'Author') : 'Defafult'}
                                // eslint-disable-next-line no-nested-ternary
                                color={!item?.isDefault ? (item?.isAdmin ? 'primary' : 'greenish') : 'orangee'}
                              />
                            </TableCell>
                            <TableCell>
                              {!item?.isAdmin && !item?.isDefault ? (
                                <FormControl sx={{ minWidth: 100 }}>
                                  <Select
                                    size="small"
                                    value={!item.isDisabled}
                                    disabled={item.isDefault}
                                    onChange={(e) => handleStatusChange(e, item, id)}
                                  >
                                    <MenuItem value="true">Enabled</MenuItem>
                                    <MenuItem value="false">Disabled</MenuItem>
                                  </Select>
                                  {selectedIndex === id && <Popup item={item} handleClose={handleClose} />}
                                </FormControl>
                              ) : (
                                <Typography>{item.isDisabled ? 'Disabled' : 'Enabled'}</Typography>
                              )}
                            </TableCell>
                            <TableCell sx={{ minWidth: '120px' }}>
                              {Moment(item.createdAt).format('YYYY-MM-DD')}
                            </TableCell>
                            <TableCell>
                              <IconButton
                                sx={{ margin: 0, padding: 0 }}
                                color="primary"
                                disabled={item.isDefault || item.isAdmin}
                                onClick={() => navigate(`/dashboard/author/view/${item._id}`)}
                              >
                                <Visibility sx={{ fontSize: '20px' }} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
                <TablePagination
                  rowsPerPageOptions={[]}
                  component={'div'}
                  count={authorCount}
                  showFirstButton
                  showLastButton
                  onPageChange={handlePageChange}
                  rowsPerPage={size}
                  page={pages}
                />
              </Card>
            </Container>
          </>
        )}
      </Page>
    </>
  );
}
